module.exports = __webpack_public_path__ + "img/seeQrcode_bg1.598914f6.png";